import React from 'react';
import { BriefcaseIcon, HeartHandshakeIcon, PresentationIcon } from 'lucide-react';
import { Section } from './Section';
import { useCases } from '../data/content';
const icons = {
  association: HeartHandshakeIcon,
  hr: BriefcaseIcon,
  training: PresentationIcon
};
export function Testimonials() {
  return <Section tone="white" eyebrow="Esempi di utilizzo" title="Il Kit si adatta al tuo contesto" data-id="element-160" data-mp="3azjcvu740eam">
      <ul className="mx-auto max-w-3xl divide-y divide-neutral-200" data-id="element-161" data-mp="3700r6w7grz6q">
        {useCases.map(useCase => {
        const Icon = icons[useCase.icon];
        return <li key={useCase.role} className="grid gap-4 py-8 first:pt-0 last:pb-0 md:grid-cols-[minmax(0,14rem)_1fr] md:gap-10" data-id="element-162" data-mp="2x0jmah01dpbt">
              <div className="flex items-start gap-3" data-id="element-163" data-mp="2s3t5frgeqppc">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-pink-900 text-pink-100" data-id="element-164" data-mp="v8dn3qgaqkei">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-165" data-mp="qb50ndo47u7g" />
                </span>
                <span data-id="element-166" data-mp="h4dckkmqpm3n">
                  <span className="block font-extrabold tracking-tight text-neutral-800" data-id="element-167" data-mp="h8181pbqwil0">
                    {useCase.role}
                  </span>
                  <span className="block text-sm text-neutral-500" data-id="element-168" data-mp="78k53fnvoisq">{useCase.city}</span>
                </span>
              </div>
              <p className="border-l-4 border-pink-600 pl-5 text-lg leading-relaxed text-neutral-800 md:text-xl" data-id="element-169" data-mp="c7dfgz7vbtoo">
                {useCase.description}
              </p>
            </li>;
      })}
      </ul>
    </Section>;
}